import React from "react";

interface AIIconProps {
  width?: number;
  height?: number;
  className?: string;
}

const AIIcon: React.FC<AIIconProps> = ({
  width = 16,
  height = 16,
  className = "",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M5.6362 2.77148C6.11684 1.36484 8.06031 1.32224 8.63017 2.64367L8.67839 2.77228L9.32702 4.66923C9.47566 5.10427 9.71587 5.50237 10.0314 5.83668C10.347 6.17099 10.7306 6.43373 11.1564 6.60718L11.3308 6.67228L13.2276 7.32014C14.6342 7.80081 14.6768 9.74438 13.3562 10.3143L13.2276 10.3625L11.3308 11.0112C10.8956 11.1597 10.4974 11.3999 10.1629 11.7155C9.8285 12.0311 9.56565 12.4147 9.39212 12.8406L9.32702 13.0142L8.67919 14.912C8.19855 16.3186 6.25508 16.3612 5.68603 15.0406L5.6362 14.912L4.98837 13.015C4.83983 12.5798 4.59966 12.1816 4.28408 11.8471C3.9685 11.5127 3.58486 11.2498 3.15904 11.0763L2.98543 11.0112L1.08858 10.3633C-0.318785 9.88263 -0.361384 7.93906 0.959981 7.36998L1.08858 7.32014L2.98543 6.67228C3.42045 6.52363 3.81853 6.2834 4.15281 5.96782C4.4871 5.65223 4.74983 5.26861 4.92327 4.84285L4.98837 4.66923L5.6362 2.77148ZM13.5877 1.45235e-07C13.7381 -1.89673e-07 13.8854 0.0421817 14.013 0.121752C14.1406 0.201322 14.2433 0.315089 14.3095 0.450124L14.348 0.544168L14.6294 1.36886L15.4548 1.65019C15.6055 1.70138 15.7376 1.79617 15.8344 1.92252C15.9311 2.04888 15.9882 2.20112 15.9984 2.35995C16.0085 2.51878 15.9713 2.67706 15.8914 2.81471C15.8115 2.95237 15.6926 3.06321 15.5496 3.13318L15.4548 3.17177L14.6302 3.45309L14.3488 4.27859C14.2976 4.42924 14.2027 4.56128 14.0763 4.65797C13.9499 4.75466 13.7977 4.81166 13.6388 4.82173C13.48 4.8318 13.3218 4.7945 13.1842 4.71455C13.0466 4.6346 12.9358 4.5156 12.8659 4.37263L12.8273 4.27859L12.546 3.4539L11.7206 3.17257C11.5699 3.12137 11.4378 3.02659 11.341 2.90023C11.2443 2.77388 11.1872 2.62164 11.177 2.4628C11.1669 2.30397 11.2041 2.1457 11.284 2.00805C11.3639 1.87039 11.4828 1.75955 11.6257 1.68957L11.7206 1.65099L12.5452 1.36966L12.8265 0.544168C12.8807 0.385359 12.9833 0.247495 13.1198 0.149906C13.2563 0.0523181 13.4199 -0.0001007 13.5877 1.45235e-07Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default AIIcon;
